<div class="col-4">
    <button type="button" class="btn btn-lg primary longSubmit" i18n="newTchek|@@addNewTchek"
        (click)="openmodal()">Nouveau Scan</button>
</div>

<ng-template #content>
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
                        (click)="modalRef.dismiss('Cross click')" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span class="title" i18n="modal_classification|@@addNewTchek">Nouveau Scan :</span>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="linetxt">
                        <p i18n="vehicle|@@matriculation">Immatriculation :</p>
                    </div>
                </div>
                <div class="col-9">
                    <div class="line">
                        <input *ngIf="saving !== true" type="text" [(ngModel)]='immat'>
                        <input *ngIf="saving === true" type="text" [(ngModel)]='immat' readonly>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    <div class="linetxt" i18n="modal_damage|@@picture">Photos : </div>
                </div>
                <div class="col-9">
                    <div class="line">

                        <div class="custom-dropzone detection-dropzone" ngx-dropzone [accept]="'image/*'"
                            (change)="onSelect($event)" [disabled]='saving'>


                            <ngx-dropzone-label class="dropzone-label">

                                <div class="row p-0 m-0 justify-content-md-center">
                                    <div class="col-9 col-md-6 buttonSend">
                                        <div class="row justify-content-md-center">
                                            <div class="col-3">
                                                <img src="../../../assets/icon/upload-file.svg" alt="">
                                            </div>
                                            <div class="col-9 center">
                                                <p i18n="new-tchek|@@downloadImageButton" class="h5 font-weight-bold">Télécharger une image</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row  p-0 m-0 justify-content-md-center">
                                    <div class="col-12 col-md-6">
                                        <p i18n="new-tchek|@@dragFile" class="smallText dark">ou déposer un fichier.</p>
                                    </div>
                                </div>

                            </ngx-dropzone-label>
                            <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" class="fileContainer"
                                *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                <!-- <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label> -->
                            </ngx-dropzone-image-preview>
                        </div>



                    </div>
                </div>
            </div>


        </div>
    </div>
    <div class="modal-footer" *ngIf="saving !== true">
        <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@cancel"
            (click)="modalRef.dismiss('Cross click')">Annuler</button>
        <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@save"
            (click)="saveTchek()"
            *ngIf="immat && immat.length > 0 && this.files && this.files.length > 0">Valider</button>
    </div>
    <div class="modal-footer" *ngIf="saving === true">
        <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@validate"
            *ngIf="immat && immat.length > 0 && this.files && this.files.length > 0">
            <img src="../../../assets/images/spinner.gif" alt="" style="width: 30; height: 30px;"> Valider</button>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/new-tchek/new-tchek.component.html